<template>
  <van-row class="page-wrapper" justify="center">
    <van-col class="itserve-center" span="24">
      <!--
      <van-notice-bar color="red" left-icon="volume-o" @click="openUrl">
        {{ $t("notice-bar.gas") }}
      </van-notice-bar>
      -->
      <van-notice-bar
        class="donora-notice"
        color="#ffffff"
        background="#239b5b"
        @click="openDonoraNotice"
      >
        <template #left-icon>
          <span class="donora-notice-heart" aria-hidden="true">
            <svg viewBox="0 0 64 64" focusable="false">
              <defs>
                <linearGradient
                  id="donoraNoticeHeartGradient"
                  x1="12"
                  y1="10"
                  x2="52"
                  y2="55"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stop-color="#ff7a7a" />
                  <stop offset="0.45" stop-color="#ff3f45" />
                  <stop offset="1" stop-color="#f5222d" />
                </linearGradient>
              </defs>
              <path
                d="M32 55S8 40.8 8 23.4C8 15.8 13.7 10 21.3 10c4.6 0 8.8 2.5 10.7 6.4C33.9 12.5 38.1 10 42.7 10 50.3 10 56 15.8 56 23.4 56 40.8 32 55 32 55Z"
              />
            </svg>
          </span>
        </template>
        {{ $t("notice-bar.donora") }}
      </van-notice-bar>

      <div v-if="account" class="account-card-wrapper">
        <div class="account-details">
          <div class="account-number">№ {{ account.ls }}</div>
          <div class="account-fio" v-if="account.fio">{{ account.fio }}</div>
          <div class="account-address" v-if="account.address || account.city">
            {{ account.address || account.city }}
          </div>
          <div class="account-balance">
            <template v-if="account.balance < 0">
              <span class="balance-label"
                >{{ $t("components.accounts.overpay") }}:</span
              >
              <span class="negative-balance"
                >{{ Math.abs(account.balance).toFixed(2) }}
                {{ $t("components.accounts.currency") }}</span
              >
            </template>
            <template v-else-if="account.balance > 0">
              <span class="balance-label"
                >{{ $t("components.accounts.debt") }}:</span
              >
              <span class="positive-balance"
                >{{ account.balance.toFixed(2) }}
                {{ $t("components.accounts.currency") }}</span
              >
            </template>
            <template v-else-if="account.balance !== undefined">
              <span class="balance-label"
                >{{ $t("components.accounts.debt") }}:</span
              >
              <span class="zero-balance"
                >0.00 {{ $t("components.accounts.currency") }}</span
              >
            </template>
            <template v-else>
              <span class="balance-label"
                >{{ $t("components.accounts.debt") }}:</span
              >
              <span class="positive-balance"
                >100 {{ $t("components.accounts.currency") }}</span
              >
            </template>
          </div>
        </div>
      </div>

      <div v-if="account" @click="runPayment" class="pay-button-container">
        <button class="pay-button big-pay-button">
          <div class="card-icon animated-icon">
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 10H23"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="button-text">
            <div class="main-text">{{ $t("buttons.payNow") }}</div>
            <div class="no-commission">{{ $t("buttons.noCommission") }}</div>
          </div>
        </button>
      </div>

      <div v-else @click="runPayment">
        <itserve-route
          :buttonName="$t('buttons.payNow')"
          class="mt-15"
        ></itserve-route>
      </div>

      <div class="main-page-account place-content-center mt-10">
        <div class="home-feature-grid">
          <router-link
            :to="{
              name: 'Donora',
              params: account ? { account: account.ls } : {},
            }"
            class="home-feature-card help-card"
          >
            <span class="home-feature-icon image-icon">
              <img :src="edopomogaLogo" alt="" />
            </span>
            <span class="home-feature-title">{{ $t("homeMenu.help") }}</span>
            <span class="home-feature-arrow">›</span>
          </router-link>

          <button
            type="button"
            class="home-feature-card"
            @click="putIndications"
          >
            <span class="home-feature-icon meter-icon">
              <send-indications-icon />
            </span>
            <span class="home-feature-title">
              {{ $t("buttons.putIndications") }}
            </span>
            <span class="home-feature-arrow">›</span>
          </button>
        </div>

        <h2 class="home-actions-title">{{ $t("homeMenu.otherActions") }}</h2>

        <section
          class="home-actions-panel"
          :aria-label="$t('homeMenu.otherActions')"
        >
          <router-link
            v-if="account"
            :to="{
              name: 'IndicationsHistory',
              params: { account: account.ls },
            }"
            class="home-action-row"
          >
            <span class="home-action-icon"
              ><clipboard-text-clock-icon :size="22"
            /></span>
            <span>{{ $t("buttons.indicationsHistory") }}</span>
          </router-link>

          <router-link
            v-if="account"
            :to="{ name: 'PaymentHistory', params: { account: account.ls } }"
            class="home-action-row"
          >
            <span class="home-action-icon"
              ><calendar-clock-icon :size="22"
            /></span>
            <span>{{ $t("buttons.paymentHistory") }}</span>
          </router-link>

          <router-link :to="{ name: 'SelectMeterage' }" class="home-action-row">
            <span class="home-action-icon"
              ><calculator-variant-icon :size="22"
            /></span>
            <span>{{ $t("buttons.energyCalculator") }}</span>
          </router-link>

          <button type="button" class="home-action-row" @click="putShutdowns">
            <span class="home-action-icon"><power-icon :size="22" /></span>
            <span>{{ $t("buttons.shutdowns") }}</span>
          </button>

          <router-link
            :to="{ name: 'WriteTicket', params: $route.params }"
            class="home-action-row"
          >
            <span class="home-action-icon"
              ><phone-in-talk-icon :size="22"
            /></span>
            <span>{{ $t("buttons.contactUs") }}</span>
          </router-link>

          <button type="button" class="home-action-row" @click="socialShare">
            <span class="home-action-icon"
              ><share-variant-icon :size="22"
            /></span>
            <span>{{ $t("buttons.socialShare") }}</span>
          </button>
        </section>
      </div>
    </van-col>
  </van-row>
</template>
<script>
import ItserveRoute from "@/components/content/ItserveRoute";
import SendIndicationsIcon from "@/components/icons/send-indications-icon-box";
import VanNoticeBar from "vant/lib/notice-bar/index";
import ClipboardTextClockIcon from "vue-material-design-icons/ClipboardClock";
import CalendarClockIcon from "vue-material-design-icons/CalendarClock";
import CalculatorVariantIcon from "vue-material-design-icons/CalculatorVariant";
import PowerIcon from "vue-material-design-icons/Power";
import PhoneInTalkIcon from "vue-material-design-icons/PhoneInTalk";
import ShareVariantIcon from "vue-material-design-icons/ShareVariant";
import edopomogaLogo from "@/assets/images/edopomoga-logo-Photoroom.png";

const DONORA_NOTICE_LINK =
  "https://donora.help/app?utm_source=zakarpattia_energo&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=energy";

export default {
  name: "Home",
  components: {
    VanNoticeBar,
    SendIndicationsIcon,
    ItserveRoute,
    ClipboardTextClockIcon,
    CalendarClockIcon,
    CalculatorVariantIcon,
    PowerIcon,
    PhoneInTalkIcon,
    ShareVariantIcon,
  },
  data() {
    return {
      edopomogaLogo,
    };
  },
  computed: {
    account() {
      return this.$store.state.Auth.account;
    },
    status() {
      return this.$store.state.Auth.status;
    },
    shareStatus() {
      return this.$store.state.Auth.share_status;
    },
    status_sub() {
      return this.$store.state.Auth.status_sub;
    },
  },
  created() {
    this.getPageData();
    this.preloadInterstitial();
    if (this.account && this.account.ls) {
      this.$store.dispatch("Auth/fetchAndScrapeAccountDetails", {
        accountId: this.account.ls,
      });
    }
  },
  methods: {
    openUrl() {
      this.nativeSendEvent("url", "https://gas-ua.online/zakarpattya.gas");
    },
    openDonoraNotice() {
      this.nativeSendEvent("url", DONORA_NOTICE_LINK);
    },
    preloadInterstitial() {
      if (!this.$store.state.Auth.isPreloaded) {
        this.nativeSendEvent("preloadInterstitial");
        this.$store.state.Auth.isPreloaded = true;
      }
    },
    async runEasyPayAllService() {
      await this.$router.push({ name: "EasyPayAllServicePage" });
    },
    async getPageData() {
      await this.$store.dispatch("Settings/getSettings");
      await this.$store.dispatch("Auth/getSubscriptionStatus");
    },
    navigateToExternalLink() {
      window.location.href = "https://onelink.to/jyeydu";
    },
    async runPayment() {
      await this.$router.push({
        name: "NoComissionPay",
        params: { account: this.account },
      });
    },
    async putIndications() {
      if (this.account) {
        this.$router.push({
          name: "SendIndications",
          params: { account: this.account.ls },
        });
      } else {
        this.$router.push({ name: "AccountsListPage" });
      }
    },
    putShutdowns() {
      this.nativeSendEvent("url", process.env.VUE_APP_SHUTDOWN);
    },
    socialShare() {
      this.nativeSendEvent("socialShare", {
        text:
          this.$t("settings.title") +
          " " +
          "https://billing.city/zakarpattya.energo",
        subject: this.$t("settings.subject"),
      });
    },
  },
};
</script>
<style scoped>
@import "../../node_modules/vant/lib/notice-bar/index.css";
@import "../../node_modules/vant/lib/list/index.css";

.donora-notice {
  font-weight: bold;
}

.donora-notice-heart {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 4px;
  line-height: 1;
}

.donora-notice-heart svg {
  width: 28px;
  height: 28px;
  display: block;
  fill: url("#donoraNoticeHeartGradient");
  filter: drop-shadow(0 0 5px rgba(255, 75, 106, 0.7));
}

.account-card-wrapper {
  background: #0e121c;
  border-radius: 12px;
  padding: 16px;
  margin: 15px 15px 0 15px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.account-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}
.account-number {
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
}
.account-fio,
.account-address {
  font-size: 16px;
  color: #bdc3c7;
}
.account-balance {
  font-size: 16px;
}
.balance-label {
  color: #bdc3c7;
}
.negative-balance,
.zero-balance {
  color: #2ecc71;
  font-weight: bold;
  margin-left: 5px;
}
.positive-balance {
  color: #e74c3c;
  font-weight: bold;
  margin-left: 5px;
}
.account-debt {
  font-size: 16px;
  color: #ffffff;
  margin-top: 8px;
}
.pay-button-container {
  padding: 0 15px;
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.pay-button {
  width: 100%;
  background-color: #4277f5;
  color: #fff;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  gap: -2px;
}

.big-pay-button {
  background: linear-gradient(135deg, #4277f5, #3a6ad8);
  border-radius: 24px;
  padding: 16px 24px;
  box-shadow: 0 0 20px rgba(66, 119, 245, 0.5);
  font-size: 18px;
}

.button-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  text-align: center;
  width: 100%;
  justify-content: center;
  margin-left: -35px;
}

.main-text {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  width: 100%;
}

.no-commission {
  font-size: 16px;
  font-weight: bold;
  opacity: 1;
  text-align: center;
  width: 100%;
}
.pay-button:hover {
  background-color: #4277f5;
}

@keyframes slide {
  0% {
    transform: translateX(-2px);
  }
  10% {
    transform: translateX(-1px);
  }
  20% {
    transform: translateX(0px);
  }
  30% {
    transform: translateX(1px);
  }
  40% {
    transform: translateX(2px);
  }
  50% {
    transform: translateX(3px);
  }
  60% {
    transform: translateX(2px);
  }
  70% {
    transform: translateX(1px);
  }
  80% {
    transform: translateX(0px);
  }
  90% {
    transform: translateX(-1px);
  }
  100% {
    transform: translateX(-2px);
  }
}

.animated-icon {
  animation: slide 2s linear infinite;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  right: 0px;
  margin-right: 0px;
}

.main-page-account {
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 0 15px 15px 15px;
  margin-top: 15px !important;
}

.main-page-account > * {
  width: 100%;
}

.home-feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: 140px;
  align-items: stretch;
  gap: 10px;
}

.home-feature-card,
.home-action-row {
  border: 0;
  appearance: none;
  color: #ffffff;
  font-family: inherit;
  text-decoration: none;
}

.home-feature-card {
  position: relative;
  height: 140px;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px 15px 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  background: #0e121c;
  box-shadow: none;
  text-align: left;
}

.home-feature-card::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
  border-radius: 0 0 12px 12px;
  background: #4277f5;
}

.home-feature-card.help-card::after {
  background: #1aad62;
}

.home-feature-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 15px;
  background: #4277f5;
  box-shadow: none;
}

.home-feature-icon.image-icon img {
  width: 38px;
  height: 38px;
  display: block;
  object-fit: contain;
}

.help-card .home-feature-icon {
  background: #050608;
}

.home-feature-icon.meter-icon {
  border-radius: 50%;
  background: #173a72;
  box-shadow: inset 0 0 0 1px rgba(92, 151, 255, 0.28);
}

.home-feature-icon.meter-icon svg {
  width: 40px !important;
  height: 40px !important;
  display: block;
  margin: 0 !important;
  opacity: 1;
  filter: contrast(1.18) brightness(1.08);
}

.home-feature-title {
  position: relative;
  z-index: 1;
  min-height: 38px;
  max-width: 112px;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 16.5px;
  font-weight: bold;
  line-height: 1.12;
  letter-spacing: 0;
}

.home-feature-arrow {
  position: absolute;
  right: 13px;
  bottom: 23px;
  color: #4277f5;
  font-size: 24px;
  font-weight: 300;
  line-height: 1;
}

.help-card .home-feature-arrow {
  color: #1aad62;
}

.home-actions-title {
  margin: 2px 0 0;
  padding: 0 0 0 1px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.12;
  letter-spacing: 0;
  text-align: left;
}

.home-actions-panel {
  overflow: hidden;
  border-radius: 12px;
  background: #0e121c;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.07);
}

.home-action-row {
  width: 100%;
  min-height: 60px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  background: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  text-align: left;
}

.home-actions-panel .home-action-row:first-child {
  border-top: 0;
}

.home-action-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #173a72;
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(92, 151, 255, 0.28);
}

.home-action-icon .material-design-icon {
  width: 22px !important;
  height: 22px !important;
  max-width: 22px;
  max-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin-top: 0 !important;
}

.home-action-icon ::v-deep .material-design-icon__svg {
  width: 22px !important;
  height: 22px !important;
  display: block;
  margin: 0 !important;
}

.home-action-row span:last-child {
  min-width: 0;
  color: #ffffff;
  font-size: 16.5px;
  font-weight: bold;
  line-height: 1.16;
  overflow-wrap: break-word;
}

@media (max-width: 360px) {
  .main-page-account {
    padding-right: 12px;
    padding-left: 12px;
  }

  .home-feature-grid {
    grid-auto-rows: 128px;
    gap: 8px;
  }

  .home-feature-card {
    height: 128px;
    padding: 12px 12px 12px;
  }

  .home-feature-icon {
    width: 44px;
    height: 44px;
    border-radius: 13px;
  }

  .home-feature-icon.image-icon img {
    width: 34px;
    height: 34px;
  }

  .home-feature-icon.meter-icon svg {
    width: 35px !important;
    height: 35px !important;
  }

  .home-feature-title {
    max-width: 92px;
    font-size: 15.5px;
  }

  .home-actions-title {
    font-size: 15.5px;
  }

  .home-action-row {
    min-height: 58px;
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 10px;
    padding: 0 12px;
  }

  .home-action-icon {
    width: 36px;
    height: 36px;
  }

  .home-action-row span:last-child {
    font-size: 15.5px;
  }
}
</style>
<style>
.page-wrapper {
  background-color: #1d1d1d !important;
  min-height: 100%;
}
.main-page-account .front {
  background: #181a1b !important;
}
.main-page-account .nav-btn-icon {
  background-color: #4277f5 !important;
}
</style>
